import Vue from 'vue';
import VueHead from 'vue-head';
Vue.use(VueHead, {
    separator: '|',
    complement: 'Version 1.0.1'
});
